/* global Vue Vue2PerfectScrollbar debounce navBlock */

Vue.component("adal-context-node", {
	template:
	'<div ' + 
		'class="vue-menu__context-node" >' + 
		'<el-popover ' + 
			'v-if="menuCollapsed" ' + 
			'placement="right" ' + 
			'width="250" ' + 
			'trigger="click" ' + 
			'popper-class="vue-menu__popper" >' + 
			'<div ' + 
				'slot="reference" ' + 
				'class="vue-menu__node__title" >' + 
				'<svg v-if="value.icon !== undefined" class="vue-menu__icon icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" >' + 
					'<use v-bind:xlink:href="\'#adal_\' + value.icon" />' + 
				'</svg>' + 
				'{{value.label}}' + 
			'</div>' + 
			'<component ' +  
				'v-bind:is="value.component" ' + 
				'v-model="componentState" ' + 
				'class="vue-menu__context-content" >' + 
			'</component>' + 
		'</el-popover>' + 
		'<template ' + 
			'v-else >' + 
			'<div ' + 
				'class="vue-menu__node__title" ' + 
				'@click="onCollapsedClick" >' + 
				'<svg v-if="value.icon !== undefined" class="vue-menu__icon icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" >' + 
					'<use v-bind:xlink:href="\'#adal_\' + value.icon" />' + 
				'</svg>' + 
				'{{value.label}}' + 
				'<svg class="vue-menu__node__collapse icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" >' + 
					'<use v-bind:xlink:href="\'#adal_arrow_\' + (collapsed ? \'down\' : \'up\')" />' + 
				'</svg>' + 
			'</div>' + 
			'<el-collapse-transition>' + 
				'<component ' + 
					'v-show="!collapsed" ' + 
					'v-bind:is="value.component" ' + 
					'v-model="componentState" ' + 
					'class="vue-menu__context-content" >' + 
				'</component>' + 
			'</el-collapse-transition>' + 
		'</template>' + 
	'</div>',
	data: function () {
		return {
			componentState: {},
			collapsed: !!localStorage.getItem("adal-menu__collapsed__" + this.value.id),
		};
	},
	methods: {
		onCollapsedClick: function () {
			if (!this.menuCollapsed)
			{
				this.collapsed = !this.collapsed;
				
				if (this.collapsed)
				{
					localStorage.setItem("adal-menu__collapsed__" + this.value.id, 1);
				}
				else
				{
					localStorage.removeItem("adal-menu__collapsed__" + this.value.id);
				}
				this.$nextTick(function () {
					this.$emit("resize");
				});
			}
		},
	},
	props: {
		value: {
			type: Object,
			required: true,
		},
		menuCollapsed: {
			type: Boolean,
			required: true,
		},
	},
});

Vue.component("adal-menu-node", {
	template: 
	'<div ' + 
		':class="nodeClasses" >' + 
		'<a ' + 
			'v-if="value.link !== undefined" ' + 
			':href="value.link" ' + 
			'class="vue-menu__node__title" ' + 
			'@click.left.passive="onClick($event, value.link)" >' + 
			'<svg v-if="value.icon !== undefined" class="vue-menu__icon icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" >' + 
				'<use v-bind:xlink:href="\'#adal_\' + value.icon" />' + 
			'</svg>' + 
			'{{value.label}}' + 
			'<span v-if="value.new" class="vue-menu__new-indicator">' +
				'New' +
			'</span>' +
		'</a>' + 
		'<el-popover ' + 
			'v-else-if="menuCollapsed && value.children !== undefined" ' + 
			'placement="right" ' + 
			'trigger="hover" ' + 
			':popper-class="[\'vue-menu__popper\', { \'__collapsed\': menuCollapsed }]" >' + 
			'<div ' + 
				'slot="reference" ' + 
				'class="vue-menu__node__title" >' + 
				'<svg v-if="value.icon !== undefined" class="vue-menu__icon icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" >' + 
					'<use v-bind:xlink:href="\'#adal_\' + value.icon" />' + 
				'</svg>' + 
				'{{value.label}}' + 
				'<span v-if="value.new" class="vue-menu__new-indicator">' +
					'New' +
				'</span>' +
			'</div>' + 
			'<adal-menu-node	' + 
				'v-for="(node, idx) in value.children" ' + 
				':key="node.id" ' + 
				'v-model="value.children[idx]" ' + 
				':menu-collapsed="menuCollapsed" ' + 
				':depth="depth + 1" ' + 
				':open-path="openPath" ' + 
				':class="{\'__first\': idx === 0, \'__last\': idx === value.children.length - 1}" ' + 
				'@resize="$emit(\'resize\')" >' + 
			'</adal-menu-node>' + 
		'</el-popover>' + 
		'<template ' + 
			'v-else >' + 
			'<div ' + 
				'class="vue-menu__node__title" ' + 
				'@click="onCollapsedClick" >' + 
				'<svg v-if="value.icon !== undefined" class="vue-menu__icon icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" >' + 
					'<use v-bind:xlink:href="\'#adal_\' + value.icon" />' + 
				'</svg>' + 
				'{{value.label}}' + 
				'<svg v-if="value.children !== undefined" class="vue-menu__node__collapse icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" >' + 
					'<use v-bind:xlink:href="\'#adal_arrow_\' + (collapsed ? \'down\' : \'up\')" />' + 
				'</svg>' + 
				'<span v-if="value.new" class="vue-menu__new-indicator">' +
					'New' +
				'</span>' +
			'</div>' + 
			'<el-collapse-transition>' + 
				'<div ' + 
					'class="vue-menu__node-container" ' + 
					'v-show="!collapsed || menuCollapsed" >' + 
					'<adal-menu-node	' + 
						'ref="childNodes" ' + 
						'v-for="(node, idx) in value.children" ' + 
						':key="node.id" ' + 
						'v-model="value.children[idx]" ' + 
						':menu-collapsed="menuCollapsed" ' + 
						':depth="depth + 1" ' + 
						':open-path="openPath" ' + 
						':class="{\'__first\': idx === 0, \'__last\': idx === value.children.length - 1}" ' + 
						'@resize="$emit(\'resize\')" ' + 
						'@open="onOpen" >' + 
					'</adal-menu-node>' + 
				'</div>' + 
			'</el-collapse-transition>' + 
		'</template>' + 
	'</div>',
	data: function () {
		return {
			collapsed: this.openPath[this.depth] !== this.value.id,
		};
	},
	computed: {
		nodeClasses: function () {
			const classes = [
				"vue-menu__node",
			];
			if (this.depth === this.openPath.length - 1 && 
				this.value.id === this.openPath[this.depth])
			{
				classes.push("__selected");
			}
			if (this.value.children && this.value.children.length)
			{
				classes.push("__group");
				classes.push(this.collapsed ? "__collapsed" : "__expanded");
			}
			if (this.value.classes)
			{
				classes.push(this.value.classes);
			}
			return classes;
		},
	},
	methods: {
		onCollapsedClick: function () {
			if (!this.menuCollapsed)
			{
				this.collapsed = !this.collapsed;
				if (!this.collapsed)
				{
					this.$emit("open", this);	
				}
				this.$nextTick(function () {
					this.$emit("resize");
				});
			}
		},
		onClick: function (e, path) {
			if (e.ctrlKey || e.metaKey) {
				return;
			}
			
			navBlock(path);
		},
		onOpen: function (openedNode) {
			this.$refs.childNodes.forEach(function (node) {
				if (node !== openedNode)
				{
					node.close();
				}
			});
		},
		close: function () {
			if (!this.collapsed)
			{
				this.collapsed = true;
				this.$nextTick(function () {
					this.$emit("resize");
				});
			}
		},
	},
	props: {
		value: {
			type: Object,
			required: true,
		},
		menuCollapsed: {
			type: Boolean,
			required: true,
		},
		depth: {
			type: Number,
			required: false,
			'default': 0,
		},
		openPath: {
			type: Array,
			required: true,
		},
		'new': {
			type: Boolean,
			required: false,
			'default': false,
		}
	},
});

Vue.component("adal-menu", {
	components: {
		"perfect-scrollbar": Vue2PerfectScrollbar.PerfectScrollbar,
	},
	template: 
	'<div ' + 
		':class="classes" >' + 
		'<perfect-scrollbar ' + 
			'ref="scrollbar" ' + 
			':options="scrollOptions" ' + 
			'class="vue-menu__content" >' + 
			'<div ' + 
				'class="vue-menu__context" ' + 
				'v-if="contextData.length > 0" >' + 
				'<adal-context-node ' + 
					'v-for="(node, idx) in contextData" ' + 
					':key="node.id" ' + 
					'v-model="contextData[idx]" ' + 
					':menu-collapsed="collapsed" ' + 
					'@resize="onResize" >' + 
				'</adal-context-node>' + 
			'</div>' + 
			'<div ' + 
				'class="vue-menu__menu" ' + 
				'v-if="menuData.length > 0" >' + 
				'<adal-menu-node ' + 
					'ref="childNodes" ' + 
					'v-for="(node, idx) in menuData" ' + 
					':key="node.id" ' + 
					'v-model="menuData[idx]" ' + 
					':menu-collapsed="collapsed" ' + 
					':open-path="openPath" ' + 
					'@resize="onResize" ' + 
					'@open="onOpen" >' + 
				'</adal-menu-node>' + 
			'</div>' + 
		'</perfect-scrollbar>' + 

		'<div ' + 
			'class="vue-menu__collapse" ' + 
			'@click="onCollapsedClick" >' + 
			'<svg class="vue-menu__icon icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" >' + 
				'<use v-bind:xlink:href="\'#adal_arrow_\' + (collapsed ? \'right\' : \'left\')" />' + 
			'</svg>' + 
			'Collapse Menu' + 
		'</div>' + 
	'</div>',
	data: function () {
		return {
			collapsed: !!localStorage.getItem("adal-menu__collapsed"),
			scrollOptions: {
				suppressScrollX: true,
			},
		};
	},
	computed: {
		classes: function () {
			const classes = ["vue-menu"];
			if (this.collapsed)
			{
				classes.push("__collapsed");
			}
			return classes;
		},
	},
	methods: {
		onCollapsedClick: function () {
			this.collapsed = !this.collapsed;
			if (this.collapsed)
			{
				localStorage.setItem("adal-menu__collapsed", 1);
			}
			else
			{
				localStorage.removeItem("adal-menu__collapsed");
			}
			this.$nextTick(function () {
				this.onResize();
			});
		},
		onResize: function () {
			this.$refs.scrollbar.ps.update();
		},
		onOpen: function (openedNode) {
			this.$refs.childNodes.forEach(function (node) {
				if (node !== openedNode)
				{
					node.close();
				}
			});
		},
	},
	props: {
		openPath: {
			type: Array,
			required: true,
		},
		contextData: {
			type: Array,
			required: true,
		},
		menuData: {
			type: Array,
			required: true,
		}
	},
	created: function () {
		const thisVue = this;
		this.onResize = debounce(function () {
			thisVue.$refs.scrollbar.ps.update();
		}, 300, {});
		window.addEventListener("resize", this.onResize);
	},
	beforeDestroy: function () {
		window.removeEventListener("resize", this.onResize);
	},
});

Vue.component("adal-services-menu-node", {
	template: 
	'<div ' + 
		':class="nodeClasses" >' + 
		'<a ' + 
			'v-if="value.link !== undefined" ' + 
			':href="value.link" ' + 
			'class="vue-menu__node__title" ' + 
			':class="anchorClasses" ' + 
			'rel="noreferrer noopener" >' + 
			'<svg v-if="value.icon !== undefined" class="vue-menu__icon icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" >' + 
				'<use v-bind:xlink:href="\'#adal_\' + value.icon" />' + 
			'</svg>' + 
			'{{value.label}}' + 
		'</a>' +
	'</div>',
	computed: {
		nodeClasses: function () {
			const classes = [
				"vue-menu__node",
			];
			if (this.value.id === this.openPath[0])
			{
				classes.push("__selected");
			}
			if (this.value.classes)
			{
				classes.push(this.value.classes);
			}
			return classes;
		},
		anchorClasses: function () {
			const classes = [];
			if (this.value.disabled)
			{
				classes.push("__disabled");
			}
			return classes;
		},
	},
	props: {
		value: {
			type: Object,
			required: true,
		},
		openPath: {
			type: Array,
			required: true,
		}
	},
});

Vue.component("adal-services-menu", {
	template: 
	'<el-popover ' + 
		'v-if="menuData.length > 0" ' +
		'placement="bottom" ' + 
		'width="250" ' + 
		'trigger="click" ' + 
		'popper-class="vue-services-menu__popper" >' + 
		'<li slot="reference" class="actionItem draftTriggerCont"">' +
			'<a class="aiButton dropdownTrigger" >' +
				'Services' +
				'<div class="menu-arrow-down"></div>' +
			'</a>' +
		'</li>' +
		'<adal-services-menu-node ' + 
			'v-for="(node, idx) in menuData" ' + 
			':key="node.id" ' + 
			'v-model="menuData[idx]" ' + 
			':open-path="openPath" ' + 
			':class="{\'__first\': idx === 0, \'__last\': idx === menuData.length - 1}" >' + 
		'</adal-services-menu-node>' +
	'</el-popover>',
	computed: {
		visibleMenuData: function () {
			return this.menuData.filter(function (menuData) {
				if (menuData.disabled != true)
				{
					return true;
				}
			});
		},
	},
	props: {
		openPath: {
			type: Array,
			required: true,
		},
		menuData: {
			type: Array,
			required: true,
		},
	},
});